import * as React from 'react';
import { __ } from '@bart.sk-eshop/react-i18n';
import { connectSsr } from '@bart.sk-eshop/ssr-service';
import { connect } from 'react-redux';
import {
  ZemplinLoaderWrapper,
  InfoText,
  RequestDetail,
} from '@bart.sk-eshop/eshop-defaults';
import {
  fetchRequestDetail,
  requestDetailDataSelector,
  requestDetailIsFetchingSelector,
} from './myAccountSlice';
import API, { ThenArg } from '../../services/API';
import { InfoType } from '@bart.sk-eshop/eshop-defaults/lib/components/Zemplin/General/InfoText';
import {
  setBreadCrumbPath,
  BreadCrumbType,
} from '../BreadCrumb/breadCrumbSlice';
import MetaTags from '../../components/_helpers/MetaTags/MetaTags';

interface Props {
  user: any;
  dispatch: any;
  data: ThenArg<typeof API.getOrder>;
  isFetching: boolean;
}

class MyRequestsDetail extends React.Component<Props> {
  public static async getInitialProps(props) {
    const {
      dispatch,
      params: { id },
    } = props;
    try {
      dispatch(setBreadCrumbPath(BreadCrumbType.MY_ACCOUNT_REQUESTS_DETAIL));
      await dispatch(fetchRequestDetail(id));
      return;
    } catch (exp) {
      console.log(exp);
      return;
    }
  }

  public render() {
    const { data, isFetching } = this.props;

    if (isFetching) {
      return <ZemplinLoaderWrapper />;
    }

    if (!data) {
      return (
        <InfoText
          type={InfoType.ERROR}
          info={__('Dopyt sa nepodarilo načítať')}
        />
      );
    }

    const { order_id } = data;

    return (
      <>
        <MetaTags
          tags={{ title: `${__('Moj účet - Detail dopytu č.')} ${order_id}` }}
        />
        <RequestDetail data={data} />
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.auth.user,
    data: requestDetailDataSelector(state),
    isFetching: requestDetailIsFetchingSelector(state),
  };
};

export default connect(mapStateToProps)(
  connectSsr({ displayName: 'MyRequestsDetail' })(MyRequestsDetail),
);
